var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row p-0 m-0"},[_c('div',{staticClass:"col-12 p-0 m-0"},[_c('viewmaker-tabs',{ref:"viewmakertabs",attrs:{"rowclick":_vm.rowclick,"togglestatus":_vm.togglestatus,"multiplerowclick":_vm.multiplerowclick},on:{"tabClick":_vm.tabClick}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ff9c25","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewmaker/viewmaker-container.vue
// module id = 1518
// module chunks = 0